import React from "react";

import './PrevNextButton.css';

const PrevNextButton = (props) => {
  const { onClick, disabled, buttonText } = props;
  const className = `prev-next-button ${disabled ? "disabled" : ""}`;
  return <div onClick={onClick} className={className}>
    {buttonText}
  </div>;
};

export default PrevNextButton;
